import { MasterclassWebComponent } from './component/MasterclassWebComponent';

export { MasterclassWebComponent };
